export default __webpack_public_path__ + "static/media/topup.31d1066b.png";